import { shallowEqual, useSelector } from 'react-redux'
import { ModalStyled } from '../../Modals.styled';
import { Backdrop, Fade } from '@mui/material'
import { RootState } from '../../../../setup'
import { modalStyles } from '../../ModalStyles';
import { KTSVG } from '../../../../_metronic/helpers';
import { UserModel } from '../../../modules/auth/models/UserModel';
import { BigSubtitle } from '../../Modals/Modals.styled';
import { useState, useEffect } from 'react';

const InsurancePromptModal = ({open, setOpen, setOpenInsuranceModal, accessorialSelected, formikValues, setFormikValues, selectedAcc, setSelectedAcc}) => {
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const classes = modalStyles({})
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const [selectedYes, setSelectedYes] = useState(false)


    useEffect(() => {
        if(!open){
            setTimeout(() => {
                setSelectedYes(false)
            }, 200);
        }
    }, [open])

    return (
        <>
                <ModalStyled
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    fontSize={fontSize}
                    open={open}
                    onClose={() => setOpen(false)}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={selectedYes ? classes.paperSaveQuoteSmall : classes.paperSaveQuote} style={{visibility: 'visible', opacity: '100%'}}>
                            <div className="row modal-header p-0 pb-2 row align-items-center">
                                <div className="col-6 d-flex align-items-center">
                                    <h5>{selectedYes ? 'Note' : accessorialSelected?.name}</h5>
                                </div>
                                <div className="col-6 d-flex justify-content-end">
                                    <div
                                        className="btn btn-icon btn-sm btn-active-light-primary"
                                        onClick={() => setOpen(false)}
                                    >
                                        <KTSVG
                                            path="/media/icons/duotune/arrows/arr061.svg"
                                            className="svg-icon svg-icon-2x"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-6 mb-6">
                                <div className="col-12">
                                    <BigSubtitle>{selectedYes ? 'Please contact your branch to insure this product' : user.insurancePrompt}</BigSubtitle>
                                </div>
                            </div>
                            <div className="row mt-1 mb-3">
                                <div className="col-12 d-flex justify-content-center">
                                    {
                                        selectedYes ?
                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    setOpen(false)
                                                }}
                                            >
                                                Ok
                                            </button>
                                        : <>
                                            <button
                                                className="btn btn-primary me-4"
                                                onClick={() => {
                                                    setSelectedYes(true)
                                                    setSelectedAcc(selectedAcc?.filter(a => a.id !== accessorialSelected.id))
                                                    setFormikValues(`accessorials.${accessorialSelected.category.toLowerCase()}`, formikValues.accessorials[accessorialSelected.category.toLowerCase()].filter(a => a.id !== accessorialSelected.id))
                                                }}
                                            >
                                                Yes
                                            </button>
                                            <button
                                                className="btn btn-danger"
                                                onClick={() => {
                                                    setOpen(false)
                                                    setOpenInsuranceModal(true)
                                                }}
                                            >
                                                No
                                            </button>
                                        </>
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    </Fade>
                </ModalStyled>
        </>
    )
}

export default InsurancePromptModal